import React from "react";
import PropTypes from "prop-types";
import cname from "./style.module.scss";
import { SliderBlock } from "../SliderBlock";
import { SwitchBlock } from "../SwitchBlock";
import { ControlBlock } from "../ControlBlock";
import { AnimationBlock } from "@learningblocks/storybook-components";

export function AnimationSlider(props) {
  const className = `${cname.animSlider} ${props.className}`;

  return (
    <div role="figure" aria-label={props.ariaLabel} className={className}>
      <AnimationBlock
        src={props.src}
        loading={props.loading}
        className={cname.animeBlock}
        orientation={props.orientation}
        currentFrame={props.currentFrame}
        animationLoaded={props.animationLoaded}
      />
      <ControlBlock loading={props.loading}>
        <SliderBlock
          text={props.text}
          {...props.sliderValue}
          loading={props.loading}
          ariaLabel={props.ariaLabel}
          onSliderChange={props.onSliderChange}
        />
        <SwitchBlock
          switchButtons={props.switchButtons}
          onToggleSwitch={props.onToggleSwitch}
        />
      </ControlBlock>
    </div>
  );
}

AnimationSlider.propTypes = {
  /**
   * Animation files to render on wide/square orientation
   */
  src: PropTypes.shape({
    /**
     * Boolean specifying if animations provided are url-path or animation-json
     */
    isPath: PropTypes.bool,
    /**
     * Animation file for 16:9 orientation
     */
    wide: PropTypes.object,
    /**
     * Animation file to 1:1 orientation
     */
    square: PropTypes.object,
  }).isRequired,
  /**
   * Orientation for Animation
   */
  orientation: PropTypes.oneOf(["wide", "square", "auto"]).isRequired,
  /**
   * Text to display on top of Slider
   */
  text: PropTypes.string,
  /**
   * Properties specific to the input-slider
   */
  sliderValue: PropTypes.shape({
    /**
     * Scale interval to display rulers
     */
    scaleInterval: PropTypes.number,
    /**
     * min value to set on slider
     */
    min: PropTypes.number,
    /**
     * max value to set on slider
     */
    max: PropTypes.number,
    /**
     * update step value for slider
     */
    step: PropTypes.number,
    /**
     * Current frame to render
     */
    current: PropTypes.number,
  }),
  /**
   * Callback for when slider thumb in moved
   */
  onSliderChange: PropTypes.func,
  /**
   * aria-label for the animation
   */
  ariaLabel: PropTypes.string,
  /**
   * Callback for when animation Finished loading
   */
  animationLoaded: PropTypes.func,
  /**
   * Boolean set to show content loaders on AnimationBlocks & SliderBlock
   */
  loading: PropTypes.bool,
  /**
   * Current frame to display ( to override sliderValue.current )
   */
  currentFrame: PropTypes.number,
  /**
   * Callback function for when toggle switch state
   */
  onToggleSwitch: PropTypes.func,
};

AnimationSlider.defaultProps = {
  orientation: "auto",
  className: "",
  currentFrame: null,
  ariaLabel: "",
  text: "",
};
